import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import bbwSite from "@/api/bbw/bbwSite";


NProgress.configure({
  showSpinner: false,
})

//路由拦截处理 同步方法，该方法里的所有await 是同步函数
router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()
  // 如果栏目列表不存在 再去获取，F5可刷新
  if (!store.getters.menus || store.getters.menus.length === 0) {
    // 获取栏目树 及 栏目列表
    await store.dispatch('permission/getMenuTree')
  }
  if (Object.keys(store.getters.site).length === 0) {
    // 获取站点信息
    await store.dispatch('permission/getSiteInfo')
  }
  if (Object.keys(store.getters.enterprises).length === 0) {
    // 获企业信息
    await store.dispatch('permission/getEnterprises')
  }
  // 设置当前激活的栏目,
  if (to.name === 'Info' || to.name === 'Detail' ||  to.name === 'Introduce') {
    console.log('getActiveMenu', to.name)
    await store.dispatch('permission/getActiveMenu', to)
  }
  next()
})

//路由拦截后处理
router.afterEach((to) => {
  // finish progress bar
  NProgress.done()
  try{
    if(to.name!=='PurchaseList' && to.name!=='PurchaseDetail'){
      bbwSite.accessRecordParse(to.name)
    }
  }catch(e){
    console.log("accessRecordParse:",e)
  }
})
